import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=a8692b00&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=tsx&"
export * from "./Info.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8692b00",
  null
  
)

export default component.exports